import { Translate } from '../../../shared/LanguageService';
import { SaveCustomerAgreementFailure } from './useSaveCustomerAgreement';

export function saveErrorText(saveError: SaveCustomerAgreementFailure | null): string {
    if (saveError === null) {
        return '';
    }

    if (saveError.messages.length > 0) {
        return saveError.messages.map((message) => Translate(message.key)).join(' ');
    }

    return Translate('customer-agreements/notification/save-failed', { name: saveError.name });
}
